import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import MainLayout from './layouts/MainLayout';

import WithdrawalList from './pages/WithdrawalList';
import PrivateRoute from './components/PrivateRoute';
import UserManagement from './pages/UserManagement';
import AdminManagement from './pages/AdminManagement';
import LendingManagement from './pages/LendingManagement';
import ReferralPage from './pages/Referral';
import EarningsManagement from './components/EarningsManagement';
import AnnouncementManagement from './pages/content/Announcements';
import ProfitRateManagement from './pages/ProfitRateManagement';
import LoanDrawManagement from './pages/LoanDrawManagement';
import EarningsHistory from './pages/EarningsHistory';

const SuperAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return user?.level_id === 1 ? <>{children}</> : <Navigate to="/users" replace />;
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* 主系统路由 */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout>
                  <UserManagement />
                </MainLayout>
              </PrivateRoute>
            }
          />
          
          {/* 提现管理路由 */}
          <Route
            path="/withdrawals"
            element={
              <PrivateRoute>
                  <MainLayout>
                    <WithdrawalList />
                  </MainLayout>
              </PrivateRoute>
            }
          />

          {/* 其他管理路由 */}
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <MainLayout>
                  <UserManagement />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/lending"
            element={
              <PrivateRoute>
                <SuperAdminRoute>
                  <MainLayout>
                    <LendingManagement />
                  </MainLayout>
                </SuperAdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/loan-draw"
            element={
              <PrivateRoute>
                <SuperAdminRoute>
                  <MainLayout>
                    <LoanDrawManagement />
                  </MainLayout>
                </SuperAdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/referral"
            element={
              <PrivateRoute>
                <MainLayout>
                  <ReferralPage />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/earnings"
            element={
              <PrivateRoute>
                  <MainLayout>
                    <EarningsManagement />
                  </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/earnings-history"
            element={
              <PrivateRoute>
                  <MainLayout>
                    <EarningsHistory />
                  </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/content/announcements"
            element={
              <PrivateRoute>
                <SuperAdminRoute>
                  <MainLayout>
                    <AnnouncementManagement />
                  </MainLayout>
                </SuperAdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <SuperAdminRoute>
                  <MainLayout>
                    <AdminManagement />
                  </MainLayout>
                </SuperAdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/profit-rate"
            element={
              <PrivateRoute>
                <SuperAdminRoute>
                  <MainLayout>
                    <ProfitRateManagement />
                  </MainLayout>
                </SuperAdminRoute>
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App; 